<template>
  <div class="hr-filterable-select">
    <div class="__label">{{ state.field.label }}</div>
    <co-select
      filterable
      should-show-search-bar-filter
      :filter-method="filterList"
      search-bar-placeholder="Search"
      v-model="state.selected"
      is-mobile-friendly
      @blur="validate"
    >
      <co-option
        v-for="item in state.list"
        is-mobile-friendly
        :data-test-id="item.value"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </co-select>
    <div v-if="state.field?.fieldError" class="__invalid">
      {{ state.field.fieldError }}
    </div>
  </div>
</template>
<script>
import { CoSelect, CoOption } from '@deputy/copilot2';
import { reactive, computed } from 'vue';

export default {
  name: 'hr-filterable-select',
  components: { CoSelect, CoOption },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:model-value', 'validate'],
  setup(props, { emit }) {
    const state = reactive({
      field: computed(() => props.modelValue),
      selected: computed({
        get: () => state.field?.value,
        set: updateSelected,
      }),
      list: props.list,
    });

    function filterList(query) {
      state.list = props.list.filter(
        (item) =>
          item.label.toLowerCase().includes(query.toLowerCase()) ||
          item.value.toLowerCase().includes(query.toLowerCase())
      );
    }

    function updateSelected(newValue) {
      state.field.value = newValue;
      state.list = props.list;
      emit('update:model-value', state.field);
    }

    function validate() {
      emit('validate', state.field);
    }

    return {
      state,
      filterList,
      validate,
    };
  },
};
</script>
<style scoped>
.hr-filterable-select {
  margin-bottom: 4px;
}
.__label {
  font-weight: 600;
  color: var(--co-text-primary);
  margin-bottom: 4px;
}
.__invalid {
  color: var(--co-text-attention);
  margin-top: 5px;
}
:deep(.co-select) {
  margin-top: 10px;
}
</style>
